
export const GET_ALL_JOBS = 'GET_ALL_JOBS';
export const GET_ALL_CHILD_JOBS = 'GET_ALL_CHILD_JOBS';
export const FETCH_ALL_JOBS = 'FETCH_ALL_JOBS';
export const FETCH_ALL_NOTIFICATIONS = 'FETCH_ALL_NOTIFICATIONS';
export const GET_ALL_NOTIFICATIONS = 'GET_ALL_NOTIFICATIONS';
export const SINGLE_SELECT_JOB = 'SINGLE_SELECT_JOB';
export const REQUESTED_BY = 'REQUESTED_BY';
export const GET_MONITORING = 'GET_MONITORING';
export const SELECT_SERVICES_DATA = 'SELECT_SERVICES_DATA';
export const SELECT_RELOCATION_DATA = 'SELECT_RELOCATION_DATA';
export const SELECT_CHANGE_EQUIPMENT = 'SELECT_CHANGE_EQUIPMENT';
export const SELECT_REMOVAL_ORDER = 'SELECT_REMOVAL_ORDER';
export const SELECT_INSTALLATION_BOSSUNIT = 'SELECT_INSTALLATION_BOSSUNIT';
export const SELECT_INSTALLATION_TIMELAPSE = 'SELECT_INSTALLATION_TIMELAPSE';
export const SELECT_INSTALLATION_XSERIES = 'SELECT_INSTALLATION_XSERIES';
export const SET_JOB_STATUS = 'SET_JOB_STATUS';
export const SELECT_INSTALLATION_TYPE = 'SELECT_INSTALLATION_TYPE';
export const SET_JOB_UPLOAD_PHOTOS = 'SET_JOB_UPLOAD_PHOTOS';
export const SEND_SMS = 'SEND_SMS';
export const SEND_SMS_DATA = 'SEND_SMS_DATA';
export const TOTAL_SERVICES = 'TOTAL_SERVICES';
export const FETCH_ALL_MEMO = 'FETCH_ALL_MEMO';
export const CALL_MEMO = 'CALL_MEMO';
export const CALL_SERVICES = 'CALL_SERVICES';
export const CALL_MONITORING = 'CALL_MONITORING';
export const PRINT_OPTION = 'PRINT_OPTION';
export const UNSAVED_MODAL_CALL = 'UNSAVED_MODAL_CALL';
export const ASSIGN_TECHNICIAN_MODAL = 'ASSIGN_TECHNICIAN_MODAL';
export const CALL_SERVICES_OF_JOBS = 'CALL_SERVICES_OF_JOBS';

const setGetAllJobs = data =>
({
    type: GET_ALL_JOBS,
    payload: { data },
});

const setGetAllChildJobs = data =>
({
    type: GET_ALL_CHILD_JOBS,
    payload: { data },
});

const setFetchAllJobs = data =>
({
    type: FETCH_ALL_JOBS,
    payload: { data },
});

const SetCallMonitoring = data =>
({
    type: CALL_MONITORING,
    payload: { data },
});

const setGetAllNotifications = data =>
({
    type: GET_ALL_NOTIFICATIONS,
    payload: { data },
});


const setFetchAllNotifications = data =>
({
    type: FETCH_ALL_NOTIFICATIONS,
    payload: { data },
});

const setFetchAllMemo = data =>
({
    type: CALL_MEMO,
    payload: { data },
});

const setFetchAllServices = data =>
({
    type: CALL_SERVICES,
    payload: { data },
});

const setSingleSelectJob = data =>
({
    type: SINGLE_SELECT_JOB,
    payload: { data },
});

const setRequestBy = data =>
({
    type: REQUESTED_BY,
    payload: { data },
});

const setMonitoringData = data =>
({
    type: GET_MONITORING,
    payload: { data },
});

const setSelectServicesData = data =>
({
    type: SELECT_SERVICES_DATA,
    payload: { data },
});

const setSelectRelocationData = data =>
({
    type: SELECT_RELOCATION_DATA,
    payload: { data },
});

const setSelectChangeOfEquipment = data =>
({
    type: SELECT_CHANGE_EQUIPMENT,
    payload: { data },
});

const setSelectRemovalOrder = data =>
({
    type: SELECT_REMOVAL_ORDER,
    payload: { data },
});

const setSelectInstallationBossUnit = data =>
({
    type: SELECT_INSTALLATION_BOSSUNIT,
    payload: { data },
});

const setSelectInstallationTimeLapse = data =>
({
    type: SELECT_INSTALLATION_TIMELAPSE,
    payload: { data },
});

const setSelectInstallationXseries = data =>
({
    type: SELECT_INSTALLATION_XSERIES,
    payload: { data },
});

const setJobStatus = data =>
({
    type: SET_JOB_STATUS,
    payload: { data },
});

const setShowInstallationSeletedType = data =>
({
    type: SELECT_INSTALLATION_TYPE,
    payload: { data },
});

const setUploadPhotos = data =>
({
    type: SET_JOB_UPLOAD_PHOTOS,
    payload: { data },
});

const setSendSMSAction = data =>
({
    type: SEND_SMS,
    payload: { data },
});

const setSendSMSData = data =>
({
    type: SEND_SMS_DATA,
    payload: { data },
});

const setTotalServices = data =>
({
    type: TOTAL_SERVICES,
    payload: { data },
});

const setAllMemoData = data =>
({
    type: FETCH_ALL_MEMO,
    payload: { data },
});

const setPrintOption = data =>
({
    type: PRINT_OPTION,
    payload: { data },
});

const setUnsavedOption = data =>
({
    type: UNSAVED_MODAL_CALL,
    payload: { data },
});

const setAssignedModal = data =>
({
    type: ASSIGN_TECHNICIAN_MODAL,
    payload: { data },
});

const setServicesofJobs = data =>
({
    type: CALL_SERVICES_OF_JOBS,
    payload: { data },
});

//GET FROM DISPATCH
export const getAllJobs = data => async dispatch => {
    try {
        dispatch(setGetAllJobs(data));
    } catch (error) {
        console.log(error);
    }
};

export const getAllChildsJobs = data => async dispatch => {
    try {
        dispatch(setGetAllChildJobs(data));
    } catch (error) {
        console.log(error);
    }
};

export const getAllNotifications = data => async dispatch => {
    try {
        dispatch(setGetAllNotifications(data));
    } catch (error) {
        console.log(error);
    }
};

export const fetchAllJobs = data => async dispatch => {
    try {
        dispatch(setFetchAllJobs(data));
    } catch (error) {
        console.log(error);
    }
};

export const fetchNotifications = data => async dispatch => {
    try {
        dispatch(setFetchAllNotifications(data));
    } catch (error) {
        console.log(error);
    }
};

export const fetchAllMemo = data => async dispatch => {
    try {
        dispatch(setFetchAllMemo(data));
    } catch (error) {
        console.log(error);
    }
};

export const fetchAllServices = data => async dispatch => {
    try {
        dispatch(setFetchAllServices(data));
    } catch (error) {
        console.log(error);
    }
};

export const singleSelectJob = data => async dispatch => {
    try {
        dispatch(setSingleSelectJob(data));
    } catch (error) {
        console.log(error);
    }
};

export const getRequestedByData = data => async dispatch => {
    try {
        dispatch(setRequestBy(data));
    } catch (error) {
        console.log(error);
    }
};

export const getMonitoringData = data => async dispatch => {
    try {
        dispatch(setMonitoringData(data));
    } catch (error) {
        console.log(error);
    }
};

export const selectServicesData = data => async dispatch => {
    try {
        dispatch(setSelectServicesData(data));
    } catch (error) {
        console.log(error);
    }
}
export const selectRelocationData = data => async dispatch => {
    try {
        dispatch(setSelectRelocationData(data));
    } catch (error) {
        console.log(error);
    }
}

export const selectChangeOfEquipment = data => async dispatch => {
    try {
        dispatch(setSelectChangeOfEquipment(data));
    } catch (error) {
        console.log(error);
    }
}

export const selectRemovalOrder = data => async dispatch => {
    try {
        dispatch(setSelectRemovalOrder(data));
    } catch (error) {
        console.log(error);
    }
}

export const selectInstallationBossUnit = data => async dispatch => {
    try {
        dispatch(setSelectInstallationBossUnit(data));
    } catch (error) {
        console.log(error);
    }
}

export const selectInstallationTimeLapse = data => async dispatch => {
    try {
        dispatch(setSelectInstallationTimeLapse(data));
    } catch (error) {
        console.log(error);
    }
}

export const selectInstallationXseries = data => async dispatch => {
    try {
        dispatch(setSelectInstallationXseries(data));
    } catch (error) {
        console.log(error);
    }
}

export const jobStatus = data => async dispatch => {
    try {
        dispatch(setJobStatus(data));
    } catch (error) {
        console.log(error);
    }
}

export const showSelectedInstallationType = data => async dispatch => {
    try {
        dispatch(setShowInstallationSeletedType(data));
    } catch (error) {
        console.log(error);
    }
}

export const uploadedJobPhotos = data => async dispatch => {
    try {
        dispatch(setUploadPhotos(data));
    } catch (error) {
        console.log(error);
    }
}

export const sendSMSAction = data => async dispatch => {
    try {
        dispatch(setSendSMSAction(data));
    } catch (error) {
        console.log(error);
    }
}

export const sendSMSData = data => async dispatch => {
    try {
        dispatch(setSendSMSData(data));
    } catch (error) {
        console.log(error);
    }
}

export const totalServices = data => async dispatch => {
    try {
        dispatch(setTotalServices(data));
    } catch (error) {
        console.log(error);
    }
}

export const allMemoData = data => async dispatch => {
    try {
        dispatch(setAllMemoData(data));
    } catch (error) {
        console.log(error);
    }
}

export const callMonitoring = data => async dispatch => {
    try {
        dispatch(SetCallMonitoring(data));
    } catch (error) {
        console.log(error);
    }
}

export const callPrintOption = data => async dispatch => {
    try {
        dispatch(setPrintOption(data));
    } catch (error) {
        console.log(error);
    }
}

export const callUnsavedOption = data => async dispatch => {
    try {
        dispatch(setUnsavedOption(data));
    } catch (error) {
        console.log(error);
    }
}

export const callAssignedModal = data => async dispatch => {
    try {
        dispatch(setAssignedModal(data));
    } catch (error) {
        console.log(error);
    }
}

export const callServicesJobs = data => async dispatch => {
    try {
        dispatch(setServicesofJobs(data));
    } catch (error) {
        console.log(error);
    }
}
